import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from '../public/locales/en/translation';
import translationVI from '../public/locales/vi/translation';
import translationJP from '../public/locales/jp/translation';
import aiEN from '../public/locales/en/teamai';
import aiVI from '../public/locales/vi/teamai';
import aiJP from '../public/locales/jp/teamai';

// the translations
const resources = {
    EN: {
        translation: translationEN,
        ai: aiEN
    },
    VI: {
        translation: translationVI,
        ai: aiVI
    },
    JA: {
        translation: translationJP,
        ai: aiJP
    }
};

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: localStorage.getItem('i18nextLng') ? localStorage.getItem('i18nextLng').toUpperCase() : 'EN',
        fallbackLng: localStorage.getItem('i18nextLng') ? localStorage.getItem('i18nextLng').toUpperCase() : 'EN',

        keySeparator: false,

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
